module.exports = __webpack_public_path__ + "media/Video 111.2019a6a6.mp4";